<template>
	<label v-if="name" for="ck-editor text-sm my-2"
		>{{ name }}
		<span v-if="required" class="text-sm text-danger">*</span></label
	>
	<ckeditor :editor="data.editor" v-model.lazy="data.editorData"></ckeditor>
</template>

<script>
	import { reactive, watch } from "vue";
	import CKEditor from "@ckeditor/ckeditor5-vue";
	import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

	export default {
		name: "BaseEditor",
		components: {
			// Use the <ckeditor> component in this view.
			ckeditor: CKEditor.component,
		},
		emits: ["updateData"],
		props: {
			defaultData: {
				type: String,
				default: "",
			},
			name: {
				type: String,
			},
			required: {
				type: Boolean,
				default: false,
			},
		},

		setup: (props, { emit }) => {
			const data = reactive({
				editor: ClassicEditor,
				editorData: "",
			});

			if (props.defaultData) {
				data.editorData = props.defaultData;
			}

			watch(
				() => data.editorData,

				(newValue, preValue) => {
					if (data.editorData) {
						emit("updateData", data.editorData);
						return;
					}
				},
			);

			return {
				data,
			};
		},
	};
</script>
